import { update } from '@intercom/messenger-js-sdk';

/**
 * Oculta o vuelve a mostrar el botón flotante de Intercom, p. ej. mientras una hoja o un modal
 * ocupa la parte de abajo de la pantalla (lo taparía). No hace nada si Intercom no está
 * configurado (ver IntercomComponent).
 *
 * @param {boolean} hidden
 */
export const setIntercomLauncherHidden = hidden => {
  if (typeof window === 'undefined' || !process.env.REACT_APP_INTERCOM_APP_ID) {
    return;
  }
  try {
    update({ hide_default_launcher: !!hidden });
  } catch (err) {
    console.warn('Intercom launcher visibility not updated', err);
  }
};
